<template>
  <div class="select-wrapper">
    <div class="label">{{ isFocus || value ? label : "" }}</div>
    <input
      type="text"
      :value="value ? value[itemText] : null"
      :placeholder="!isFocus ? placeholder : ''"
      readonly
      @click.self="isFocus = !isFocus"
    />

    <div class="items" v-if="loading && isFocus">
      <p>Loading...</p>
    </div>
    <div class="items" v-if="items.length > 0 && isFocus && !loading">
      <input type="text" @input="search($event.target.value)" />
      <ul>
        <li
          class="item"
          v-for="item in items"
          :key="item[itemKey]"
          @click="select(item)"
          :class="{ active: value === item }"
        >
          {{ item[itemText] }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {}
    },

    placeholder: {
      type: String,
      default: ""
    },

    label: {
      type: String,
      default: ""
    },

    itemKey: {
      type: String,
      default: "id"
    },

    itemText: {
      type: String,
      default: "text"
    },

    items: {
      type: Array,
      default: () => {
        return [];
      }
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isFocus: false
    };
  },

  methods: {
    select(item) {
      this.$emit("input", item);
      this.isFocus = false;
    },

    search(e) {
      setTimeout(() => {
        let item = this.$el.querySelectorAll("li.item");
        let txtValue = "";
        for (let i = 0; i < item.length; i++) {
          txtValue = item[i].textContent || item[i].innerText;
          if (txtValue.toUpperCase().indexOf(e.toUpperCase()) > -1) {
            item[i].style.display = "";
          } else {
            item[i].style.display = "none";
          }
        }
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
.select-wrapper {
  position: relative;
  padding: 20px 0 10px 0;

  .label {
    color: #5a5a65;
    font-family: $Quicksand;
    font-size: 14px;
    position: absolute;
    top: 0;
    left: 0;
  }

  input {
    width: 100%;
    border-radius: 5px;
    padding: 10px;
    border: 1px solid #a7a7a7;
    cursor: pointer;
    font-size: 18px;
    color: #7f908c;

    &:focus {
      border-color: $color4;
    }
  }

  .items {
    position: absolute;
    top: 65px;
    left: 0;
    z-index: 2;
    background-color: #fff;
    border: 1px solid #a7a7a7;
    width: 100%;

    p {
      padding: 5px 10px;
      color: #5a5a65;
      text-align: center;
      font-size: 14px;
      width: 100%;
    }

    input {
      height: 40px;
      padding: 5px;
      font-size: 12px;
      padding: 5px 10px;
    }

    ul {
      overflow-y: auto;
      list-style: none;
      width: 100%;
      height: auto;
      max-height: 200px;

      li {
        padding: 5px 10px;
        font-size: 14px;
        color: #5a5a65;
        cursor: pointer;

        &:hover,
        &.active {
          color: #3dbfcd;
        }
      }
    }
  }
}
</style>
